import { useTranslation } from 'next-i18next'

import DrillTopicElementsList from '~/components/Drill/DrillTopic/components/DrillTopicElemetsList'
import DrillTopicGridLayout from '~/components/Drill/DrillTopic/components/DrillTopicGridLayout'
import DrillTopicGridWrapper from '~/components/Drill/DrillTopic/components/DrillTopicGridWrapper'
import LianaDesktop from '~/components/Drill/DrillTopic/components/LianaDesktop'
import LianaMobile from '~/components/Drill/DrillTopic/components/LianaMobile'
import LianaTablet from '~/components/Drill/DrillTopic/components/LianaTablet'
import useGetGridPositionFunction from '~/components/Drill/hooks/useGetGridPositionFunction'
import { TopicData } from '~/types/theory'
import { processTopics } from '~/components/Drill/DrillTopic/helpers'

import { getGridPosition } from './Powers.grid'
import { getProperties } from './Powers.properties'

export default function Powers({
  topics,
  drillUrl,
}: {
  topics: TopicData[] | undefined
  drillUrl: string
}): React.ReactElement {
  const { t } = useTranslation(['drill'])
  const getGridPositionFunction = useGetGridPositionFunction(getGridPosition)
  const processedTopics = processTopics(topics, getGridPositionFunction, getProperties)

  const mobileGridRows = 'grid-rows-[repeat(38,70px)]'
  const tabletGridRows = 'md:grid-rows-[repeat(18,70px)]'
  const desktopGridRows = 'xl:grid-rows-[repeat(22,70px)]'

  return (
    <DrillTopicGridWrapper>
      <div className="md:hidden">
        <LianaMobile height={2850} />
      </div>
      <div className="hidden md:block xl:hidden">
        <LianaTablet
          image="math-drills/powers/beanstalk-tablet.png"
          imageAlt={t('drill:imageAlt.powerBeanStalkTablet')}
        />
      </div>
      <div className="hidden xl:block">
        <LianaDesktop
          classNames="-top-28 -left-28 w-[1050px]"
          height={1728}
          image="math-drills/powers/beanstalk-desktop.png"
          imageAlt={t('drill:imageAlt.powerBeanStalkDesktop')}
        />
      </div>
      <DrillTopicGridLayout className={[mobileGridRows, tabletGridRows, desktopGridRows].join(' ')}>
        <DrillTopicElementsList drillUrl={drillUrl} topics={processedTopics} />
      </DrillTopicGridLayout>
    </DrillTopicGridWrapper>
  )
}
